import filters from "./filters/filters";
import LazyLoadingComponent from "../../../common/ts/components/LazyLoadingComponent";
import {connect} from "../../../common/ts/connect";
import pagination from "./pagination/pagination";
import location from "../../../common/ts/core/location";
import dom from "../../../common/ts/core/dom";
import tracking from "../../../common/ts/core/tracking";
import sorting from "./sorting/sorting";
import breadcrumb from "./breadcrumb/breadcrumb";
import emailRetention from "../components/retention/email/main";
import cmpAdsManager from "./cmpAdsManager/cmpAdsManager";
import http from "../../../common/ts/core/http";
import localStorage from "../../../common/ts/core/localStorage";
import webpush from "./webpush/webpush";
import googleOneTap from "./googleOneTap/googleOneTap";
import dfpRightBlock from "../components/dfpRightBlock/dfpRightBlock";
import {LISTINGS_SELECTOR, NAVBAR_SELECTOR, USER_SEARCH_SELECTOR} from "../selectors";
import {EventBus} from "../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import userSearchEventHandlers from "../components/userSearch/eventHandlers";
import {SerpClickSimilarAdsRequestedEvent, SerpClickSimilarAdsRequestedPayload, SerpLoadedEvent} from "./events";
import {isDesktopDevice, isMobileDevice} from "../device";
import autocomplete from "./filters/autocomplete";
import propertyTypeDropdown from "../components/propertyTypeDropdown";
import {FILTER_SEARCH_ID, GEO_SEARCH_ID} from "../../../common/ts/serp/filters/constants";
import chips from "./chips";
import homeSearchBoxForm from "../components/homeSearchBoxForm";
import {FindIntent, Snippet} from "../components/snippet/snippet";
import SaveSearchModal from "../../../common/ts/components/modals/retention/SaveSearchModal";
import {EMAIL_RETENTION_VISITED_LOCATIONS_LOCAL_STORAGE_KEY} from "../components/retention/email/main/constants";
import {SECTION_IMPRESSION} from "../../../common/ts/tracking/constants";
import SectionImpressionData from "../../../common/ts/SectionImpressionData";

const FIRST_RIGHT_DFP_SELECTOR = '.js-dfp-right-block__top';
const eventBus = EventBus.getInstance();

export interface MitulaSerpPageData {
    device: string;
    search: string;
    operationType: string;
    propertyType: string;
    filters: string;
    geoEntity: string;
    pageviewId: string;
    pageNumber: number;
    isPaid: boolean;
    formId: string;
    freeText: string;
    geoSlug: string;
    findIntent: FindIntent;
    isGDPRCountry: boolean;
    shouldShowProjectSnippet: boolean;
    shouldRequestWebPushPermission: boolean;
    shouldShowGoogleOneTapOnLoad: boolean;
    shouldShowEmailRetentionModal: boolean;
    splitTestFF: { [key: string]: string };
}
declare global {
    interface Window {
        serpSectionImpressionData: SectionImpressionData;
        similarSectionImpressionData: SectionImpressionData;
    }
}
(window as any).initPage = (pageData: MitulaSerpPageData) => {
    connect(() => {
        let emailRetentionModal = new SaveSearchModal(pageData.search, pageData.isPaid, !isMobileDevice(pageData.device), "save-email-retention-form", "#email-retention-modal", false);
        emailRetentionModal.init();
        eventHandlers.init();
        dom.init();
        location.init();
        tracking.init();
        http.init();
        localStorage.init();
        cmpAdsManager.init(eventBus, pageData.shouldShowGoogleOneTapOnLoad);
        sorting.init();
        new LazyLoadingComponent().setupLazyLoading();
        filters.init(pageData);
        userSearchEventHandlers.init();
        breadcrumb.init();
        pagination.init();
        webpush.init();
        googleOneTap.init(pageData.device, emailRetentionModal);
        chips.init(pageData);
        propertyTypeDropdown.init();
        homeSearchBoxForm.init(pageData.pageviewId, true);
        dfpRightBlock.init({
            topBoundaryElement: dom.select(USER_SEARCH_SELECTOR),
            topSiblingElement: dom.select(FIRST_RIGHT_DFP_SELECTOR),
            bottomBoundaryElement: dom.select(LISTINGS_SELECTOR),
            navbarElement: dom.select(NAVBAR_SELECTOR),
        });
        emailRetention.init({
            search: pageData.search,
            pageNumber: pageData.pageNumber,
            isPaid: pageData.isPaid,
            toggleTrackingName: isMobileDevice(pageData.device) ? 'email-retention-bottom-receive-news' : 'email-retention-modal-receive-news',
            submitTrackingName: isMobileDevice(pageData.device) ? 'email-retention-bottom-submit' : 'email-retention-modal-submit',
            isDesktop: isDesktopDevice(pageData.device),
        });
        let saveSearchModalFirstStep = new SaveSearchModal(pageData.search, pageData.isPaid, !isMobileDevice(pageData.device), "save-actual-search-form");
        saveSearchModalFirstStep.init();

        [FILTER_SEARCH_ID, GEO_SEARCH_ID].forEach((id) => {
            autocomplete.init({
                id: id,
                geoSlug: pageData.geoSlug,
            });
        });
        new Snippet({
            pageViewId: pageData.pageviewId,
            search: pageData.search,
            getSimilarsEvent: (params) => {
                const paramsWithIntent = {...params, findIntent: pageData.findIntent, splitTestFF:pageData.splitTestFF};
                eventBus.emit(
                    new SerpClickSimilarAdsRequestedEvent(paramsWithIntent as SerpClickSimilarAdsRequestedPayload)
                );
            },
            eventBus: eventBus,
            findIntent: pageData.findIntent,
        }).init();

        eventBus.emit(new SerpLoadedEvent({
            search: pageData.search,
            shouldShowEmailRetentionModal: pageData.shouldShowEmailRetentionModal || false,
            saveSearchModal:emailRetentionModal,
            shouldShowProjectSnippet: pageData.shouldShowProjectSnippet || false,
            shouldRequestWebPushPermission: pageData.shouldRequestWebPushPermission || false,
            shouldShowGoogleOneTapOnLoad: pageData.shouldShowGoogleOneTapOnLoad || false,
            storedSearches: localStorage.getItem(EMAIL_RETENTION_VISITED_LOCATIONS_LOCAL_STORAGE_KEY),
            operationType: pageData.operationType,
            filters: pageData.filters,
            geoEntity: pageData.geoEntity,
            pageviewId: pageData.pageviewId,
            serpUrl: window.location.href,
            device: pageData.device,
            isGDPRCountry: pageData.isGDPRCountry,
        }))

        if(window.serpSectionImpressionData) {
            eventBus.emit(new tracking.TrackWebTrackingEvent({
                type: SECTION_IMPRESSION,
                serpUrl: window.location.href,
                pageViewId: pageData.pageviewId,
                filters: window.serpSectionImpressionData,
            }))
        }
    });
}